import { Box, IconButton, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CsvColumn, downloadCsv } from "./csv-export";

interface ExportCsvButtonProps<T> {
  rows: T[];
  columns: CsvColumn<T>[];
  fileName: string;
  label?: string;
}

const ExportCsvButton = <T,>({
  rows,
  columns,
  fileName,
  label = "Export CSV",
}: ExportCsvButtonProps<T>) => (
  <Tooltip title={label}>
    {/* The span keeps the tooltip working while the button is disabled. */}
    <Box component="span">
      <IconButton
        size="small"
        aria-label={label}
        disabled={rows.length === 0}
        onClick={() => downloadCsv(fileName, rows, columns)}
      >
        <FileDownloadIcon fontSize="small" />
      </IconButton>
    </Box>
  </Tooltip>
);

export default ExportCsvButton;
